import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { colorIconActionOption, colorBgInteractiveSelected, colorBgInteractiveActive, colorText, colorIconLight, space2, space3, space4, } = theme();
    const styles = StyleSheet.create({
        button: {
            alignItems: "center",
            alignSelf: "stretch",
            flexDirection: "row",
            flex: 1,
            gap: space4,
            justifyContent: "center",
            minHeight: 40,
            minWidth: 56,
            paddingHorizontal: space3,
            paddingVertical: space2,
        },
        icon: {
            flexShrink: 0,
        },
        text: {
            textAlign: "center",
        },
    });
    return {
        ...styles,
        colorBgInteractiveSelected,
        colorBgInteractiveActive,
        colorText,
        colorIconActionOption,
        colorIconLight,
    };
};
export { style };
